import { Loader } from '@navikt/ds-react'
import styles from './Spinner.module.css'

interface Props {
    tekst?: string
}

const Spinner = ({ tekst }: Props) => {
    return (
        <div className={styles.container}>
            <Loader />
            <p className={styles.tekst}>{tekst}</p>
        </div>
    )
}

export default Spinner
